import { Label } from "./ui/label";

/** Form field label with required-asterisk / (optional) convention.
 *  - required: red "*"
 *  - optional (default): small muted "(optional)" suffix
 *  Both markers are inlined into the same label so screen readers announce
 *  them together with the field name.
 */
export default function FieldLabel({ required = false, children, className = "", testid }) {
  return (
    <Label className={`text-xs text-[#5C665A] inline-flex items-center gap-1 ${className}`} data-testid={testid}>
      <span>{children}</span>
      {required ? (
        <span className="text-[#C94A4A]" aria-label="required" title="required">*</span>
      ) : (
        <span className="text-[11px] text-[#5C665A]/70">(optional)</span>
      )}
    </Label>
  );
}

export function RequiredLegend({ className = "" }) {
  return (
    <div className={`text-[11px] text-[#5C665A] ${className}`} data-testid="required-legend">
      <span className="text-[#C94A4A]">*</span> required
    </div>
  );
}
